import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/inventory-categories/profile/loading';

export const Route = createFileRoute('/_private/settings/inventory-categories/$id')({
  pendingComponent: Loading,
});
